import type React from 'react';

import * as styles from './styles';
import type { SvgIconProps } from '@material-ui/core/SvgIcon';

export enum LabelType {
  Text = 0,
  Unit = 1,
  Currency = 2,
}

export interface CardItem {
  value: number | string;
  labelType: LabelType;
  label?: React.ReactElement | string;
  icon?: React.ReactElement<SvgIconProps>;
  fontSize?: string;
}

interface HighlightCardProps {
  title: string;
  isActive: boolean;
  content: CardItem[];
  className?: string;
  id?: string;
}

export const HighlightCard: React.FC<HighlightCardProps> = ({
  title,
  isActive,
  content,
  className,
  id,
}) => {
  const renderLabel = (
    label: React.ReactElement | string,
    labelType: LabelType
  ) => <span className={styles.label(labelType, isActive)}>{label}</span>;

  const renderCardContent = () => (
    <div className={styles.container}>
      {content.map(({ value, label, labelType, icon, fontSize }, index) => (
        <div key={index} className={styles.labelContent}>
          {icon}
          {label &&
            labelType === LabelType.Currency &&
            renderLabel(label, labelType)}
          <span style={{ fontSize }} className={styles.value(isActive)}>
            {value}
          </span>
          {label &&
            labelType !== LabelType.Currency &&
            renderLabel(label, labelType)}
        </div>
      ))}
    </div>
  );

  return (
    <div className={`${styles.item} ${className || ''}`} id={id || ''}>
      {renderCardContent()}
      <div className={styles.titleWrapper}>
        <span className={styles.titleText(isActive)}>{title}</span>
      </div>
    </div>
  );
};
